import { httpClient as i } from "../../../utils/http-client.mjs";
const o = async (t) => i.post("/api/public/digital-store/opt-in", t);
export {
  o as handleOptin
};
